<template>
    <div class="l-container-content bg-white">
    
        <div class="row">
            <div class="col-6">
                <div class="input inline">
                    <input name="dates" placeholder="Choose date" />
                </div>
            </div>
            <div class="col-6 text-right">
                <div class="input inline">
                    <input v-on:keyup.enter="searchRecord" type="text" placeholder="Search..." v-model="search_match">
                </div>
            </div>
        </div>
    
        <div class="row">
            <loader v-show='loading' />
    
            <vuetable v-show='!loading' class="table table-bordered table-striped" ref="vuetable" :http-options="httpOptions" :api-url="url" :fields="columns" :css="css.table" :sort-order="sortOrder" track-by="paybill" :append-params="moreParams" :per-page="10" @vuetable:pagination-data="onPaginationData"
                @vuetable:loading="onLoading" @vuetable:loaded="onLoaded">
    
                <div slot="action" slot-scope="props">
                    <b-dropdown id="dropdown-left" text="Action" variant="primary" class="m-2">
                        <b-dropdown-item @click="showBoostedModal(props.rowData)"><i class="fas fa-reply-all"></i> Boosted</b-dropdown-item>
                        <b-dropdown-divider></b-dropdown-divider>
                        <b-dropdown-item @click="showTopModal(props.rowData)"><i class="fas fa-star"></i> Top</b-dropdown-item>
                        <b-dropdown-divider></b-dropdown-divider>
                        <b-dropdown-item @click="showPriortyModal(props.rowData)"><i class="icon-upload-alt"></i> Priority</b-dropdown-item>
                        <b-dropdown-divider></b-dropdown-divider>
    
                    </b-dropdown>
                </div>
    
            </vuetable>
        </div>
        <div class="vuetable-pagination row" v-show='!loading'>
            <div class="col text-left">
                <vuetable-pagination-info ref="paginationInfo"></vuetable-pagination-info>
            </div>
            <div class="col">
                <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage">
                </vuetable-pagination>
            </div>
        </div>
        <b-modal ref="create-boosted-modal" hide-footer :title="'Boost Match ID: ' +selectedMatch.parent_match_id ">
            <div v-show="errorcreateStatus">
                <small class="text-red">{{errorsMessage}}</small>
            </div>
            <div class="l-form row">
                <div class="col-12">
                    <label>Comment *</label>
                    <textarea rows="2" class="w-full block border bg-white rounded-md outline-none text-xs" style="width: 100%;" v-model="boostComment" required />
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <b-button class="mt-2" variant="outline-success" block @click="createBoosted" id="saveMatch">Save Match</b-button>
                </div>
                <div class="col-6">
                    <b-button class="mt-2" variant="outline-danger" block @click="hideBoostedModal">Cancel</b-button>
                </div>
            </div>
        </b-modal>
        <b-modal ref="create-top-modal" hide-footer :title="'Create Top Match ID: ' +selectedMatch.parent_match_id ">
            <div v-show="errorcreateStatus">
                <small class="text-red">{{errorsMessage}}</small>
            </div>
            <div class="l-form row">
                <div class="col-12">
                    <label>Comment *</label>
                    <textarea rows="2" class="w-full block border bg-white rounded-md outline-none text-xs" style="width: 100%;" v-model="boostComment" required />
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <b-button class="mt-2" variant="outline-success" block @click="createTop" id="saveMatch">Save Match</b-button>
                </div>
                <div class="col-6">
                    <b-button class="mt-2" variant="outline-danger" block @click="hideBoostedModal">Cancel</b-button>
                </div>
            </div>
        </b-modal>
        <b-modal ref="create-priority-modal" hide-footer :title="'Priority Match ID: ' +selectedMatch.parent_match_id ">
            <div v-show="errorcreateStatus">
                <small class="text-red">{{errorsMessage}}</small>
            </div>
            <div class="l-form row">
                <div class="col-12">
                    <label>Priority *</label>
                    <input type="number" v-model="selectedMatch.priority" placeholder="Enter Priority">
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <b-button class="mt-2" variant="outline-success" block @click="createPriority" id="saveMatch">Save Priority</b-button>
                </div>
                <div class="col-6">
                    <b-button class="mt-2" variant="outline-danger" block @click="hidePriortydModal">Cancel</b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<style lang="scss" scoped>
.ui.fixed.table {
    table-layout: auto !important;
}

td {
    white-space: nowrap;
    &.vuetable-slot {
        overflow: visible !important;
    }
}
</style>

<script>
import Vuetable from 'vuetable-2/src/components/Vuetable'
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
import loader from "@/components/loader"
import tableCss from "@/components/css.js";
import store from "../../store";
import $ from "jquery";

export default {
    components: {
        Vuetable,
        VuetablePagination,
        VuetablePaginationInfo,
        loader
    },
    name: 'approvals',

    data() {
        return {
            url: "https://interactiveapi.chezagame.com/sportbook/portal/v1/matche/view",
            httpOptions: {
                headers: {
                    'X-App-Key': '09lib74145Qb3HO6eQTIfsbylRkyuZFT',
                    'X-Authorization-Key': 'ADMIN_APP',
                    'X-Requested-With': 'XMLHttpRequest',
                    'X-Token-Key': this.$cookies.get("accessToken")
                }
            },
            css: tableCss,
            loading: true,
            selected_data: {},
            selectedMatch: {
                parent_match_id: "",
                boosted: 0,
                priority: 1

            },
            boostComment: "",
            columns: [

                {
                    name: 'match_id',
                    title: 'Match ID',
                    sortField: 'match_id',
                    titleClass: '',
                    dataClass: '',

                },
                {
                    name: "parent_match_id",
                    title: 'Parent Match ID',
                    sortField: 'parent_match_id',
                    callback: 'createdAt'
                },
                {
                    name: "home_team",
                    title: 'Home Team',
                    sortField: 'home_team',
                },
                {
                    name: "away_team",
                    title: 'Away Team',
                    sortField: 'away_team',
                },
                {
                    name: 'priority',
                    title: 'Priority',
                    sortField: 'priority',
                    titleClass: 'center aligned',
                    dataClass: 'center aligned'

                },
                {
                    name: 'start_time',
                    title: 'Start Time',
                    sortField: 'start_time',
                    titleClass: '',
                    dataClass: ''

                },
                {
                    name: 'boosted',
                    title: 'Boosted',
                    sortField: 'boosted',
                    titleClass: '',
                    dataClass: ''
                },
                {
                    name: "ft_score",
                    title: 'Result',
                    sortField: 'ft_score',
                },
                {
                    name: "created",
                    title: 'created',
                    sortField: 'created',
                }, {
                    name: "action",
                    title: 'Action',
                }

            ],
            range: '',
            search_match: '',
            loadOnStart: true,
            sortOrder: [{
                field: 'start_time',
                direction: 'ASC'
            }],
            is_partial_resulting: false,

            moreParams: {
                start: '',
                filter: '',
                end: ''
            },
            errorcreateStatus: false,
            errorsMessage: ""

        }
    },


    mounted() {
        //var headerHeight = document.getElementById('header').offsetHeight;
        //document.getElementById('main-content').style.top = headerHeight + 'px';

        var vm = this;

        var start = moment();
        var end = moment();

        function cb(start, end) {
            vm.dateFilter(start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'));
            $('input[name="dates"]').val(start.format('D MMMM, YYYY') + ' - ' + end.format('D MMMM, YYYY'));
        }

        $('input[name="dates"]').daterangepicker({
            startDate: start,
            endDate: end,
            ranges: {
                'Today': [moment(), moment()],
                'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                'This Month': [moment().startOf('month'), moment().endOf('month')],
                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
            }
        }, cb);

        cb(start, end);

    },




    watch: {

        data(newVal, oldVal) {
            this.$refs.vuetable.refresh();
        },
        range() {

            var start = this.range[0];
            var end = this.range[1];
            start = moment(start).format('YYYY-MM-DD');
            end = moment(end).format('YYYY-MM-DD');
            this.moreParams.start = start;
            this.moreParams.end = end;
            this.$refs.vuetable.refresh();
        }
    },


    methods: {

        showTopModal(app) {
            this.$refs['create-top-modal'].show()
            this.selectedMatch = app
            this.errorcreateStatus = false
            this.errorsMessage = ""
        },
        hideTopdModal() {
            this.$refs['create-top-modal'].hide()
            this.$refs.vuetable.refresh();
            this.errorcreateStatus = false
            this.errorsMessage = ""
        },
        showPriortyModal(app) {
            this.$refs['create-priority-modal'].show()
            this.selectedMatch = app
            this.errorcreateStatus = false
            this.errorsMessage = ""
        },
        hidePriortydModal() {
            this.$refs['create-priority-modal'].hide()
            this.$refs.vuetable.refresh();
            this.errorcreateStatus = false
            this.errorsMessage = ""
        },

        showBoostedModal(app) {
            this.$refs['create-boosted-modal'].show()
            this.selectedMatch = app
            this.errorcreateStatus = false
            this.errorsMessage = ""

        },
        hideBoostedModal() {
            this.$refs['create-boosted-modal'].hide()
            this.$refs.vuetable.refresh();
            this.errorcreateStatus = false
            this.errorsMessage = ""
        },
        createTop() {
            let vm = this
            $("#saveMatch").html('<i class="fa fa-spinner fa-spin"></i> Loading...');
            $.post({
                url: store.state.rootUrl + 'sportbook/portal/v1/matche/top',
                type: "POST",
                headers: {
                    "X-App-Key": "09lib74145Qb3HO6eQTIfsbylRkyuZFT",
                    "X-Authorization-Key": "ADMIN_APP",
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/json",
                    "X-Token-Key": vm.$cookies.get("accessToken")
                },
                data: JSON.stringify({
                    parent_match_id: vm.selectedMatch.parent_match_id,
                    status: 1,

                }),
                success: function(response, status, jQxhr) {
                    $("#saveMatch").text("Save Match");
                    if (response.data.code == 200) {
                        vm.hideTopdModal()
                    } else {

                        vm.errorcreateStatus = true;
                        vm.successcreateStatus = false;
                        vm.errorsMessage = response.data.message;
                    }

                },
                error: function(jQxhr, status, error) {
                    $("#saveMatch").text("Save Match");
                    var statustext = jQxhr.responseJSON.statusDescription;
                    vm.errorcreateStatus = true;
                    vm.successcreateStatus = false;
                    vm.errorsMessage = jQxhr.responseJSON.data.message;
                }
            });
        },
        createBoosted() {
            let vm = this
            $("#saveMatch").html('<i class="fa fa-spinner fa-spin"></i> Loading...');
            $.post({
                url: store.state.rootUrl + 'sportbook/portal/v1/matche/boosted',
                type: "POST",
                headers: {
                    "X-App-Key": "09lib74145Qb3HO6eQTIfsbylRkyuZFT",
                    "X-Authorization-Key": "ADMIN_APP",
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/json",
                    "X-Token-Key": vm.$cookies.get("accessToken")
                },
                data: JSON.stringify({
                    parent_match_id: vm.selectedMatch.parent_match_id,
                    status: 1,

                }),
                success: function(response, status, jQxhr) {
                    $("#saveMatch").text("Save Match");
                    if (response.data.code == 200) {
                        vm.hideBoostedModal()
                    } else {

                        vm.errorcreateStatus = true;
                        vm.successcreateStatus = false;
                        vm.errorsMessage = response.data.message;
                    }

                },
                error: function(jQxhr, status, error) {
                    $("#saveMatch").text("Save Match");
                    var statustext = jQxhr.responseJSON.statusDescription;
                    vm.errorcreateStatus = true;
                    vm.successcreateStatus = false;
                    vm.errorsMessage = jQxhr.responseJSON.data.message;
                }
            });
        },
        createPriority() {
            let vm = this
            $("#savePriority").html('<i class="fa fa-spinner fa-spin"></i> Loading...');
            $.post({
                url: store.state.rootUrl + 'sportbook/portal/v1/matche/priority/update',
                type: "POST",
                headers: {
                    "X-App-Key": "09lib74145Qb3HO6eQTIfsbylRkyuZFT",
                    "X-Authorization-Key": "ADMIN_APP",
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/json",
                    "X-Token-Key": vm.$cookies.get("accessToken")
                },
                data: JSON.stringify({
                    parent_match_id: vm.selectedMatch.parent_match_id,
                    priority: vm.selectedMatch.priority,

                }),
                success: function(response, status, jQxhr) {
                    $("#savePriority").text("Save Priority");
                    if (response.data.code == 200) {
                        vm.hidePriortydModal()
                    } else {

                        vm.errorcreateStatus = true;
                        vm.successcreateStatus = false;
                        vm.errorsMessage = response.data.message;
                    }

                },
                error: function(jQxhr, status, error) {
                    $("#savePriority").text("Save Priority");
                    var statustext = jQxhr.responseJSON.statusDescription;
                    vm.errorcreateStatus = true;
                    vm.successcreateStatus = false;
                    vm.errorsMessage = jQxhr.responseJSON.data.message;
                }
            });
        },

        dateFilter: function(start, end) {

            var vm = this;


            vm.start = start;
            vm.end = end;


            vm.moreParams.start = start;
            vm.moreParams.end = end;

            this.$refs.vuetable.refresh();

            console.log("start date filter", start)
            console.log("end date filter ", end)
        },
        createdAt: function(value) {
            if (!value) {
                return '-';
            } else {
                return moment(value).format('h:mm a,DD MMM YYYY');
            }

        },

        searchRecord: function() {
            this.moreParams.filter = this.search_match;
            this.$refs.vuetable.refresh();
        },

        dataManager(sortOrder, pagination) {
            if (this.data.length < 1) return;

            let local = this.data;

            // sortOrder can be empty, so we have to check for that as well
            if (sortOrder.length > 0) {
                console.log("orderBy:", sortOrder[0].sortField, sortOrder[0].direction);
                local = _.orderBy(
                    local,
                    sortOrder[0].sortField,
                    sortOrder[0].direction
                );
            }

            pagination = this.$refs.vuetable.makePagination(
                local.length,
                this.perPage
            );
            console.log('pagination:', pagination)
            let from = pagination.from - 1;
            let to = from + this.perPage;

            return {
                pagination: pagination,
                data: _.slice(local, from, to)
            };
        },


        onPaginationData(paginationData) {
            this.$refs.paginationInfo.setPaginationData(paginationData)
            this.$refs.pagination.setPaginationData(paginationData)
        },


        onChangePage(page) {
            this.$refs.vuetable.changePage(page)
        },

        onLoading() {
            this.loading = true
            console.log('loading... show your spinner here')
        },
        onLoaded() {
            this.loading = false
            console.log('loaded! .. hide your spinner here');
            $(".ui.dropdown").dropdown();
        },




    },


}
</script>